<template>
    <div
        :id="'category-' + data.id"
        :data-category-id="data.id"
        class="position-relative transition-all"
    >
                <div
                    class="category-box d-flex flex-column justify-center align-center transition-all position-relative"
                    :data-category-id="data.id"
                    @click="setActiveCategories"
                    >
                    <div class="category-image" :id="'cat-' + data.id">
                        <img
                            :src="
                                'https://assets.beereaders.com/beauty_categories/' +
                                data.id +
                                '.png'
                            "
                            @load="handleLoad"
                            class="category-img transition-all"
                            alt="Cat"
                        />
                        <v-btn
                            icon
                            x-small
                            class="btn-info"
                            @click.stop="dialog = true">
                            <v-img
                                :src="require('@/assets/img/icons/icon-info.png')"
                                height="32"
                                width="32"
                            ></v-img>
                        </v-btn>
                        <v-skeleton-loader
                            v-if="!loaded"
                            class="position-absolute mb-9 opacity-none grey lighten-1"
                            height="60"
                            width="80"
                            type="image"
                            :transition="'scale-transition'"
                        ></v-skeleton-loader>
                        <span class="category-name">{{ data.name }}</span>
                    </div>
                    <div
                        class="pa-0 ma-0 position-absolute check transition-all"
                    >
                        <v-icon class="purple-text transition-all white rounded-circle "
                            >mdi-checkbox-marked-circle</v-icon
                        >
                    </div>
                </div>

        <v-dialog
            v-model="dialog"
            max-width="340"
            overlay-color="#514585"
            overlay-opacity="0.9"
            >
            <v-card style="background: white;" class="py-5 border-radius-2">
                <v-row align="center" justify="center" class="ma-0">
                    <v-col cols="12">
                        <img
                            :src="
                                'https://assets.beereaders.com/beauty_categories/' +
                                data.id +
                                '.png'
                            "
                            @load="handleLoad"
                            class="category-img mx-auto transition-all"
                            style="height:128px"
                            width="128"
                            :alt="data.name"
                        />
                    </v-col>
                </v-row>
                <v-card-title class="text-center justify-content-center">
                    {{ data.name }}
                </v-card-title>
                <v-card-text>
                    {{ data.description }}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        outlined
                        class="text-transform-none border-radius-1 mx-auto px-6"
                        @click="dialog = false"
                    >
                    {{ $t('profile.understood') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        data: {},
        selected: { type: Boolean, default: false },
    },
    data() {
        return {
            info: false,
            loaded: false,
            dialog: false,
        }
    },
    mounted() {
        if (this.selected) {
            this.setActiveCategories()
        }
    },
    methods: {
        setActiveCategories() {
            const el = document.querySelector(`#category-${this.data.id}`)
            el.classList.toggle('category-active')
        },
        handleLoad() {
            this.loaded = true
        },
    },
}
</script>
<style lang="scss">
.category-box {
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0px 6px 12px 0px #0000001A;
    width: 100%;
    height: 17.5vh;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    padding: 3vh;
    border: 1px #e8e8e8;
    border-style: hidden;
    @media screen and (max-width: 600px) {
        height: 16vh;
        width: 100%;    
    }
}

.category-image {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
}

.category-name {
    font-family: 'Poppins', sans-serif !important;
    color: #323A46;
    font-size: 14px;
    line-height: 120%;
    font-weight: 600;
    @media screen and (max-width: 600px) {
        font-size: 12px;
        margin-top: 2vh;
    }
}
.border-color-blue {
    border-color: #514773;
}
.check {
    display: none;
}

.category-active .check {
    display: block !important;
    bottom: -2vh;
    right: -2vh;
}

.category-info:before {
    content: '';
    position: absolute;
    top: 10px;
    left: -20px;
    height: 10px;
    width: 20px;
    transform-origin: bottom left;
    z-index: -1;
    border-top: 30px solid transparent;
    border-right: 70px solid #e4f4f2;
    border-bottom: 30px solid transparent;
}

.text-short {
    max-width: 200px;
    font-size: 12px;
}
.v-icon.purple-text{
    border-style: solid;
    border-width: 2px;
    color: #7764CA;
    caret-color: #7764CA;
}

.btn-info{
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 8px;
    margin-right: 8px;
    @media screen and (max-width: 600px) {
        margin-top: 4px;
        margin-right: 2px;        
    }
}
</style>
